import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Book, Zap, Shield, Target, Dumbbell, Trophy } from 'lucide-react';
const tomos = [{
  id: 1,
  title: 'LA VENTAJA OCULTA DEL ZURDO',
  subtitle: 'Cómo dejar de jugar “neutral” y empezar a dominar con patrones incómodos',
  icon: <Book className="w-6 h-6" data-id="element-149" />,
  content: [{
    title: 'Capítulo 1 — El error del zurdo amateur',
    items: ['Jugar como un diestro invertido', 'Por qué desperdician sus mejores ángulos', 'Cómo leen mal la cancha']
  }, {
    title: 'Capítulo 2 — La biomecánica del zurdo',
    items: ['Diferencias de timing', 'Distancias de impacto', 'Ventajas naturales en cruzado', 'Cómo generar más incomodidad']
  }, {
    title: 'Capítulo 3 — Mentalidad táctica del zurdo',
    items: ['Cómo hacer sentir incómodo al rival', 'El “caos controlado”', 'Ritmos y pausas']
  }, {
    title: 'Capítulo 4 — Posicionamiento ideal',
    items: ['Dónde debe jugar un zurdo', 'Cómo cubrir el medio', 'Errores comunes de posicionamiento']
  }, {
    title: 'Capítulo 5 — Patrones ganadores',
    items: ['Globo + víbora', 'Salida rápida paralela', 'Cruzado pesado', 'Bandeja al cuerpo']
  }, {
    title: 'Capítulo 6 — Diagramas visuales',
    items: ['Flechas tácticas', 'Posiciones', 'Trayectorias ideales']
  }],
  includes: ['Diagramas de cancha', 'Mapas de impacto', 'Ejemplos visuales', '“Errores típicos del zurdo”']
}, {
  id: 2,
  title: 'EL ATAQUE DEL ZURDO',
  subtitle: 'Cómo usar tus ángulos para dominar puntos',
  icon: <Zap className="w-6 h-6" data-id="element-150" />,
  content: [{
    title: 'Capítulo 1 — La cruzada mortal',
    items: ['Cómo abrir la cancha', 'Ángulos imposibles', 'Cómo forzar bolas cortas']
  }, {
    title: 'Capítulo 2 — Víbora de zurdo',
    items: ['Diferencias con el diestro', 'Dirección ideal', 'Alturas', 'Efectos']
  }, {
    title: 'Capítulo 3 — Bandeja ofensiva',
    items: ['Bandeja profunda', 'Bandeja al cuerpo', 'Bandeja para recuperar red']
  }, {
    title: 'Capítulo 4 — Smash táctico',
    items: ['Por 3', 'Por 4', 'Recuperación', 'Cuándo NO rematar']
  }, {
    title: 'Capítulo 5 — Ataque en pareja',
    items: ['Zurdo + diestro', 'Zurdo + zurdo', 'Cómo dominar el medio']
  }, {
    title: 'Capítulo 6 — Ejercicios de ataque',
    items: ['Secuencias', 'Conos', 'Objetivos', 'Entrenamientos progresivos']
  }],
  includes: ['Diagramas de ataque', 'Trayectorias', 'Zonas calientes', 'Rutinas técnicas']
}, {
  id: 3,
  title: 'DEFENSA INTELIGENTE DEL ZURDO',
  subtitle: 'Cómo defender sin regalar puntos',
  icon: <Shield className="w-6 h-6" data-id="element-151" />,
  content: [{
    title: 'Capítulo 1 — Defensa con pared',
    items: ['Rebotes difíciles', 'Ajuste corporal', 'Timing']
  }, {
    title: 'Capítulo 2 — Recuperación táctica',
    items: ['Cómo volver a neutral', 'Defensa activa vs pasiva']
  }, {
    title: 'Capítulo 3 — Globos inteligentes',
    items: ['Globo ofensivo', 'Globo de escape', 'Globo cruzado']
  }, {
    title: 'Capítulo 4 — Cómo defender jugadores agresivos',
    items: ['Contra smashers', 'Contra voleadores', 'Contra jugadores rápidos']
  }, {
    title: 'Capítulo 5 — Lectura de juego',
    items: ['Anticipación', 'Cómo detectar direcciones', 'Lenguaje corporal rival']
  }, {
    title: 'Capítulo 6 — Circuitos defensivos',
    items: ['Drills completos', 'Defensa + transición', 'Resistencia específica']
  }],
  includes: ['Circuitos visuales', 'Diagramas de recuperación', 'Ejercicios de reacción']
}, {
  id: 4,
  title: 'TACTICAS AVANZADAS PARA ZURDOS',
  subtitle: 'El libro que transforma un jugador técnico en uno difícil de vencer',
  icon: <Target className="w-6 h-6" data-id="element-152" />,
  content: [{
    title: 'Capítulo 1 — Cómo manipular espacios',
    items: ['Crear huecos', 'Mover rivales', 'Ritmos']
  }, {
    title: 'Capítulo 2 — El uso del cuerpo rival',
    items: ['Jugar incómodo', 'Pelotas al hombro', 'Pelotas al pie']
  }, {
    title: 'Capítulo 3 — Tácticas según rival',
    items: ['Contra defensivos', 'Contra pegadores', 'Contra veteranos', 'Contra jóvenes rápidos']
  }, {
    title: 'Capítulo 4 — Patrones profesionales',
    items: ['Secuencias reales', 'Cómo piensan los pros zurdos']
  }, {
    title: 'Capítulo 5 — Dominio psicológico',
    items: ['Cómo frustrar rivales', 'Lenguaje corporal', 'Control emocional']
  }, {
    title: 'Capítulo 6 — Diagramas avanzados',
    items: ['Puntos completos', 'Secuencias tácticas', 'Decisiones en tiempo real']
  }],
  includes: ['Diagramas estilo coach', 'Mapas tácticos', '“Qué haría un pro”']
}, {
  id: 5,
  title: 'ENTRENAMIENTO ESPECIFICO PARA ZURDOS',
  subtitle: 'Cómo entrenar como zurdo y no como jugador genérico',
  icon: <Dumbbell className="w-6 h-6" data-id="element-153" />,
  content: [{
    title: 'Capítulo 1 — Preparación física',
    items: ['Potencia lateral', 'Rotación', 'Core específico']
  }, {
    title: 'Capítulo 2 — Movilidad y prevención',
    items: ['Hombro', 'Codo', 'Lumbar', 'Rodilla']
  }, {
    title: 'Capítulo 3 — Reflejos y reacción',
    items: ['Ejercicios visuales', 'Reacción corta']
  }, {
    title: 'Capítulo 4 — Entrenamiento técnico semanal',
    items: ['Rutina 3 días', 'Rutina 5 días', 'Rutina amateur']
  }, {
    title: 'Capítulo 5 — Entrenamiento con compañero',
    items: ['Ejercicios coordinados', 'Automatismos']
  }, {
    title: 'Capítulo 6 — Planes completos',
    items: ['Pre torneo', 'Competencia', 'Recuperación']
  }],
  includes: ['Calendarios', 'Planillas', 'Drills visuales']
}, {
  id: 6,
  title: 'ESTRATEGIAS DE COMPETENCIA',
  subtitle: 'Cómo ganar más partidos aunque no tengas mejor técnica',
  icon: <Trophy className="w-6 h-6" data-id="element-154" />,
  content: [{
    title: 'Capítulo 1 — Cómo leer un partido',
    items: ['Momentum', 'Tendencias', 'Debilidades']
  }, {
    title: 'Capítulo 2 — Gestión emocional',
    items: ['Nervios', 'Cierres', 'Tiebreaks']
  }, {
    title: 'Capítulo 3 — Cómo jugar torneos',
    items: ['Calentamiento', 'Energía', 'Recuperación']
  }, {
    title: 'Capítulo 4 — Estrategias según nivel',
    items: ['5ta', '4ta', '3ra', 'Competitivo']
  }, {
    title: 'Capítulo 5 — El “manual anti-zurdo”',
    items: ['Lo que hacen contra vos', 'Cómo contrarrestarlo']
  }, {
    title: 'Capítulo 6 — Partidos comentados',
    items: ['Ejemplos tácticos completos', 'Diagramas play-by-play']
  }],
  includes: ['Análisis visuales', 'Partidos explicados', 'Tácticas reales']
}];
export function TomosAccordion() {
  const [openId, setOpenId] = useState<number | null>(1);
  const toggleAccordion = (id: number) => setOpenId(openId === id ? null : id);
  return <section className="py-20 px-4 bg-brand-dark" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <div className="text-center mb-12" data-id="element-157">
          <h2 className="font-display text-3xl md:text-5xl text-white uppercase mb-4" data-id="element-158">
            Lo que vas a recibir:{' '}
            <span className="text-brand-green" data-id="element-159">6 Tomos completos</span>
          </h2>
          <p className="font-body text-gray-400 text-lg" data-id="element-160">
            Hacé clic en cada tomo para ver el contenido detallado.
          </p>
        </div>

        <div className="space-y-4" data-id="element-161">
          {tomos.map(tomo => <div key={tomo.id} className={`border-2 rounded-xl overflow-hidden transition-colors duration-300 ${openId === tomo.id ? 'border-brand-green' : 'border-white/10 hover:border-brand-green/50'}`} data-id="element-162">
              <button onClick={() => toggleAccordion(tomo.id)} className={`w-full flex items-center justify-between p-5 md:p-6 text-left transition-colors ${openId === tomo.id ? 'bg-brand-green/5' : 'bg-brand-card'}`} data-id="element-163">
                <div className="flex items-center gap-4" data-id="element-164">
                  <div className={`p-3 rounded-lg ${openId === tomo.id ? 'bg-brand-green text-brand-black' : 'bg-white/5 text-gray-400'}`} data-id="element-165">
                    {tomo.icon}
                  </div>
                  <div data-id="element-166">
                    <h3 className="font-display text-xl md:text-2xl text-white uppercase" data-id="element-167">
                      TOMO {tomo.id} — {tomo.title}
                    </h3>
                    <p className="font-body text-sm md:text-base text-gray-400 font-medium mt-1" data-id="element-168">
                      {tomo.subtitle}
                    </p>
                  </div>
                </div>
                <ChevronDown className={`w-6 h-6 text-gray-500 transition-transform duration-300 shrink-0 ${openId === tomo.id ? 'rotate-180 text-brand-green' : ''}`} data-id="element-169" />
              </button>

              <AnimatePresence data-id="element-170">
                {openId === tomo.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-171">
                    <div className="p-6 md:p-8 bg-brand-card border-t border-white/5" data-id="element-172">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-173">
                        <div className="space-y-6" data-id="element-174">
                          {tomo.content.map((cap, idx) => <div key={idx} data-id="element-175">
                              <h4 className="font-display text-lg text-white mb-2" data-id="element-176">
                                {cap.title}
                              </h4>
                              <ul className="space-y-1.5" data-id="element-177">
                                {cap.items.map((item, i) => <li key={i} className="font-body text-gray-400 flex items-start gap-2" data-id="element-178">
                                    <span className="text-brand-green font-bold mt-0.5" data-id="element-179">
                                      •
                                    </span>
                                    {item}
                                  </li>)}
                              </ul>
                            </div>)}
                        </div>

                        <div className="bg-brand-black p-6 rounded-xl h-fit border border-brand-green/20" data-id="element-180">
                          <h4 className="font-display text-lg text-white mb-4 flex items-center gap-2" data-id="element-181">
                            <span data-id="element-182">📊</span> Incluye:
                          </h4>
                          <ul className="space-y-3" data-id="element-183">
                            {tomo.includes.map((item, i) => <li key={i} className="font-body text-brand-green font-medium flex items-center gap-2" data-id="element-184">
                                <div className="w-1.5 h-1.5 rounded-full bg-brand-green" data-id="element-185"></div>
                                {item}
                              </li>)}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-186">
          <a href="https://checkout.ebookpoint.shop/cart/59466975805521:1" className="inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-darkGreen text-brand-black font-display text-xl py-4 px-8 rounded-xl transition-all transform hover:scale-105 hover:shadow-xl hover:shadow-brand-green/30 w-full md:w-auto" data-id="element-187">
            QUIERO USAR MI ZURDA COMO VENTAJA
          </a>
        </div>
      </div>
    </section>;
}